<template>
  <form class="row" @submit.prevent="createChannel()">
    <!-- Encabezado propio solo cuando se llega desde el selector de caminos. -->
    <div v-if="showBack" class="small-12 columns manual-setup__header">
      <page-header
        :header-title="$t('INBOX_MGMT.ADD.WHATSAPP.MANUAL_SETUP.TITLE')"
        :header-content="$t('INBOX_MGMT.ADD.WHATSAPP.MANUAL_SETUP.DESC')"
      />
    </div>

    <div class="medium-8 columns">
      <label :class="{ error: $v.inboxName.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.LABEL') }}
        <woot-input-channel-name
          v-model.trim="inboxName"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.PLACEHOLDER')"
          :error="
            $v.inboxName.$error
              ? $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.ERROR')
              : ''
          "
          @focusout.native="$v.inboxName.$touch"
        />
        <p
          v-if="!$v.inboxName.$error"
          class="help-text manual-setup__name-help"
        >
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.HELP') }}
        </p>
      </label>
    </div>

    <div class="medium-8 columns">
      <label :class="{ error: $v.phoneNumber.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.LABEL') }}
        <input
          v-model.trim="phoneNumber"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.PLACEHOLDER')"
          @blur="$v.phoneNumber.$touch"
        />
        <p v-if="!$v.phoneNumber.$error" class="help-text">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.HELP') }}
        </p>
        <span v-if="$v.phoneNumber.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.ERROR') }}
        </span>
      </label>
    </div>

    <!-- Requisito previo: en este camino Conversa no registra el número en Meta. -->
    <div v-if="showBack" class="medium-8 columns">
      <warning-callout
        :title="$t('INBOX_MGMT.ADD.WHATSAPP.MANUAL_SETUP.REQUIREMENT_TITLE')"
      >
        <p>{{ $t('INBOX_MGMT.ADD.WHATSAPP.MANUAL_SETUP.REQUIREMENT') }}</p>
      </warning-callout>
    </div>

    <div class="medium-8 columns">
      <label :class="{ error: $v.phoneNumberId.$error }">
        <span>
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER_ID.LABEL') }}
        </span>
        <input
          v-model.trim="phoneNumberId"
          type="text"
          :placeholder="
            $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER_ID.PLACEHOLDER')
          "
          @blur="$v.phoneNumberId.$touch"
        />
        <p v-if="!$v.phoneNumberId.$error" class="help-text">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER_ID.HELP') }}
        </p>
        <span v-if="$v.phoneNumberId.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER_ID.ERROR') }}
        </span>
      </label>
    </div>

    <div class="medium-8 columns">
      <label :class="{ error: $v.businessAccountId.$error }">
        <span>
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.BUSINESS_ACCOUNT_ID.LABEL') }}
        </span>
        <input
          v-model.trim="businessAccountId"
          type="text"
          :placeholder="
            $t('INBOX_MGMT.ADD.WHATSAPP.BUSINESS_ACCOUNT_ID.PLACEHOLDER')
          "
          @blur="$v.businessAccountId.$touch"
        />
        <p v-if="!$v.businessAccountId.$error" class="help-text">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.BUSINESS_ACCOUNT_ID.HELP') }}
        </p>
        <span v-if="$v.businessAccountId.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.BUSINESS_ACCOUNT_ID.ERROR') }}
        </span>
      </label>
    </div>

    <div class="medium-8 columns">
      <label :class="{ error: $v.apiKey.$error }">
        <span>
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.API_KEY.LABEL') }}
        </span>
        <input
          v-model.trim="apiKey"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.API_KEY.PLACEHOLDER')"
          @blur="$v.apiKey.$touch"
        />
        <p v-if="!$v.apiKey.$error" class="help-text">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.API_KEY.HELP') }}
        </p>
        <span v-if="$v.apiKey.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.API_KEY.ERROR') }}
        </span>
      </label>
    </div>

    <div class="medium-8 columns">
      <label>
        {{
          $t(
            'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_ENABLE_DATA_EXTRACTION.LABEL'
          )
        }}
        <select v-model="enableDataExtraction">
          <option :value="true">
            {{
              $t(
                'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_ENABLE_DATA_EXTRACTION.ENABLED'
              )
            }}
          </option>
          <option :value="false">
            {{
              $t(
                'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_ENABLE_DATA_EXTRACTION.DISABLED'
              )
            }}
          </option>
        </select>
        <p class="help-text">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.MANUAL_SETUP.INSIGHTS_HELP') }}
        </p>
      </label>
    </div>

    <div class="medium-12 columns">
      <woot-submit-button
        :loading="uiFlags.isCreating"
        :disabled="$v.inboxName.$invalid"
        :button-text="$t('INBOX_MGMT.ADD.WHATSAPP.SUBMIT_BUTTON')"
      />
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import { required, maxLength } from 'vuelidate/lib/validators';
import PageHeader from '../../SettingsSubPageHeader';
import WarningCallout from 'dashboard/components/ui/WarningCallout';
import router from '../../../../index';
import { isPhoneE164OrEmpty, isNumber } from 'shared/helpers/Validators';

export default {
  components: {
    PageHeader,
    WarningCallout,
  },
  mixins: [alertMixin],
  props: {
    // true cuando se llega desde el selector de caminos (paso 2 del wizard).
    showBack: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inboxName: '',
      phoneNumber: '',
      apiKey: '',
      phoneNumberId: '',
      businessAccountId: '',
      enableDataExtraction: false,
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  validations: {
    inboxName: { required, maxLength: maxLength(30) },
    phoneNumber: { required, isPhoneE164OrEmpty },
    apiKey: { required },
    phoneNumberId: { required, isNumber },
    businessAccountId: { required, isNumber },
    enableDataExtraction: { required },
  },
  methods: {
    async createChannel() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      try {
        const whatsappChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.inboxName,
            enable_data_extraction: this.enableDataExtraction,
            channel: {
              type: 'whatsapp',
              phone_number: this.phoneNumber,
              provider: 'whatsapp_cloud',
              provider_config: {
                api_key: this.apiKey,
                phone_number_id: this.phoneNumberId,
                business_account_id: this.businessAccountId,
              },
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: whatsappChannel.id,
          },
        });
      } catch (error) {
        this.showAlert(this.$t('INBOX_MGMT.ADD.WHATSAPP.API.ERROR_MESSAGE'));
      }
    },
  },
};
</script>

<style scoped lang="scss">
.manual-setup {
  // El encabezado ocupa toda la fila; PageHeader trae sus propias columnas.
  &__header {
    padding-left: 0;
    padding-right: 0;
  }

  // El campo de nombre trae su propia fila de contador; la ayuda va debajo de ella.
  &__name-help {
    margin-top: var(--space-smaller);
  }
}
</style>
